import { connect, ConnectedProps } from "react-redux";
import { AppDispatch, RootState } from "store";
import { actions, slotTemplatesSelector } from "reducers/slotTemplates";
import { useCallback } from "react";
import { actions as templateModalActions } from "reducers/slotTemplateModal";
import SlotsTemplatesTable from "./SlotsTemplatesTable";
import { SlotTemplatesFilterType } from "reducers/types/slotTemplates";
import { SlotsTemplatesTableContainerProps } from "./types";

const SlotTemplatesTableContainer = (
  props: SlotsTemplatesTableContainerProps & ConnectorProps
) => {
  const { getTemplates, filters, filtersExtraSeeMore } = props;
  const seeMoreTemplates = useCallback(() => {
    getTemplates({ ...filters, ...filtersExtraSeeMore });
  }, [getTemplates, filters, filtersExtraSeeMore]);

  const openModal = (templateId: number) => {
    props.getTemplateDetail(templateId);
    props.openDetailModal(true);
  };

  return (
    <SlotsTemplatesTable
      {...props}
      onSeeMoreClick={seeMoreTemplates}
      openModal={openModal}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  templates: slotTemplatesSelector(state).templates,
  filters: slotTemplatesSelector(state).filters,
  filtersExtraSeeMore: slotTemplatesSelector(state).filtersExtraSeeMore,
  seeMore: slotTemplatesSelector(state).seeMore,
  collapse: slotTemplatesSelector(state).collapseTable,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  getTemplates: (params: SlotTemplatesFilterType) => {
    dispatch(actions.getSlotTemplatesRequest(params));
  },
  getTemplateDetail: (id: number) => {
    dispatch(templateModalActions.getDetailTemplateRequest(id));
  },
  openDetailModal: (show: boolean) => {
    dispatch(actions.toggleDetailModalVisibility(show));
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connector(SlotTemplatesTableContainer);
